module.exports = {"title":"Nutzungsbedingungen","content":"Nutzungsbedingungen","link":"https://karamba.com/info/terms"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/de/terms.json
// module id = 502
// module chunks = 248 1660